import axios from 'axios'

const api = axios.create({
  baseURL: 'https://api.peakslog.com'
})

// Add request interceptor to include JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['X-Access-Token'] = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Add response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - logout user
      localStorage.removeItem('token')
      window.location.href = '/login'
    } else if (error.response?.status >= 500 && !error.config?.optional) {
      // Server error - redirect to error page
      // (żądania oznaczone { optional: true }, np. /api/regions, obsługuje sam widok)
      window.location.href = '/error'
    }
    return Promise.reject(error)
  }
)

export default api